import { AsyncAction } from '../../types'
import { oAuthParamsSelector } from '../hooks'
import { unwrapResult } from '@reduxjs/toolkit'
import { confirmAccessCheckout } from './api'
import { isPortalApiError } from '@afterpaytouch/portal-api/utils'
import { shouldAttemptAccountLink, toOAuthScopeArray } from '../../../utils/oAuth'
import { checkoutStatusSelector } from '../../checkout/hooks'
import { CheckoutStatus } from '../../../model'

export const shouldShowOAuthConsentForm: AsyncAction<boolean> = async (dispatch, getState) => {
  const oAuthState = oAuthParamsSelector(getState())
  const checkoutStatus = checkoutStatusSelector(getState())
  if (shouldAttemptAccountLink(oAuthState) && checkoutStatus !== CheckoutStatus.Error) {
    try {
      const { clientId, scope, responseType, redirectUri } = oAuthState
      const response = unwrapResult(
        await dispatch(
          confirmAccessCheckout({
            clientId,
            scopes: toOAuthScopeArray(scope),
            grantType: responseType,
            redirectUri,
          })
        )
      )
      return !isPortalApiError(response)
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}
